import { useState } from 'react'

interface SpotlightButtonProps {
  children: React.ReactNode
  hue?: number
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  className?: string
  disabled?: boolean
}

const SpotlightButton = ({
  children,
  hue = 4000,
  onClick,
  type = 'button',
  className = '',
  disabled = false,
}: SpotlightButtonProps) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 })
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    })
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`relative px-6 py-3 rounded-[50px] font-medium transition-all duration-500 border-0 outline-0 overflow-hidden bg-[#FF3F34] text-white ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      style={{
        boxShadow: isHovered && !disabled
          ? `0 0 20px hsla(${hue}, 95%, 60%, 0.5)`
          : '0 0 0 hsla(0, 0%, 0%, 0)',
      }}
    >
      {/* Overlay con efecto spotlight */}
      {!disabled && (
        <span
          className="absolute inset-0 pointer-events-none transition-opacity duration-400"
          style={{
            opacity: isHovered ? 1 : 0,
            background: `radial-gradient(circle 150px at ${mousePos.x}px ${mousePos.y}px, hsla(${hue}, 95%, 60%, 0.8), transparent 100%)`,
          }}
        />
      )}
      <span className="relative z-10">{children}</span>
    </button>
  )
}

export default SpotlightButton
